import React, { useState, useEffect, forwardRef } from "react";
import { Spin, Button, Tooltip, Popconfirm } from "antd";
import { useDispatch } from "react-redux";
import SectionHeader from "../../components/global/SectionHeader";
import { API_URL } from "../../environment";
import { ALLLEAVES_DATA } from "../../redux/Store/constants";
import {
  DeleteColumnOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusSquareOutlined,
} from "@ant-design/icons";
import { useNavigate, Link } from "react-router-dom";
import "./requestLeave.css";
import MaterialTable from "material-table";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import { useSidebar } from "../../components/provider/Provider";
import moment from "moment";
import Layout from "../../components/global/layout";
import Swal from "sweetalert2";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../components/loader";
import { IoInformationCircleSharp } from "react-icons/io5";

const requestedLeaveForm = (props) => {
  const Email = localStorage.getItem("Email");

  const token = localStorage.getItem("token");
  const [form, setForm] = useState({
    reason: "",
  });
  const [rejectedData, setRejectedData] = useState({});
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState(false);
  const [employeeData, setEmployeeData] = useState({});
  const [array, setArray] = useState([]);
  const { setCourseId } = useSidebar();
  const dispatch = useDispatch();

  const navigate = useNavigate();
  useEffect(() => {
    userDetails();
    EmployeeDetails();
  }, []);

  const EmployeeDetails = () => {
    const userid = localStorage.getItem("USERID");
    fetch(`${API_URL}userDetail?id=${userid}`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setEmployeeData(res);
      });
  };

  const setReasonModal = () => {
    setReason(false);
  };

  const userDetails = () => {
    setLoading(true);
    fetch(`${API_URL}leavesList?email=${Email}&count=1000&isDeleted=false`, {
      method: "GET",

      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setArray(res && res.data);
        if (res && res.data && res.data.access_token) {
          dispatch({
            type: ALLLEAVES_DATA,
            payload: res,
          });
        }
        if (res.code === 401) {
          localStorage.clear();
          navigate("/");
        }
        setLoading(false);
      });
  };

  const changeStatus = (e, item) => {
    console.log(item);
    setRejectedData(item);

    if (e.target.value != "Rejected") {
      let data = {
        leaveId: item.id,
        tl_approval_status: e.target.value,
        fromemail: Email,
        Reason: "Your Leave is Approved",
      };
      Swal.fire({
        title: "Are you sure?",
        text: `Do you want to mark this as ${e.target.value}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#EFA332",
        cancelButtonColor: "#949494",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          ApiClient.allApi("leaveApproval", data, "post").then((res) => {
            if (res.success) {
              userDetails();
            }
          });
        }
      });
    } else {
      setReason(true);
    }
  };

  const handelSubmit = (e) => {
    e.preventDefault();
    loader(true);
    let data = {
      leaveId: rejectedData.id,
      tl_approval_status: "Rejected",
      fromemail: Email,
      Reason: form.text ? form.text : "",
    };
    ApiClient.allApi("leaveApproval", data, "post").then((res) => {
      if (res.success) {
        loader(false);
        userDetails();
        setReasonModal();
      }
      // loader(false);
    });
  };

  const chapterIdHandle = (id) => {
    setCourseId(id);
    localStorage.setItem("appliedlives", id);
  };
  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      field: "leaveStartDate",
      render: (text, record) => (
        <>
          <Link to={`/leaveDetails?id=${text.id}`} className="text">
            <Tooltip title="View">
              <span
                className="text text-capitalize text-link d-inline m-0"
                onClick={() => chapterIdHandle(text.id)}
              >
                {text.employeeName}
              </span>
            </Tooltip>
          </Link>
        </>
      ),
    },

    {
      title: "Type",
      dataIndex: "subject",
      field: "subject",
      render: (text, record) => (
        <>
          {text && text.subject ? (
            <span
              className="text-capitalize"
              onClick={() => chapterIdHandle(text.id)}
            >
              {text.subject}
            </span>
          ) : (
            "--"
          )}
        </>
      ),
    },

    {
      title: "Leave Start Date",
      dataIndex: "leaveStartDate",
      field: "leaveStartDate",
      render: (text, record) => (
        <>{moment(text && text.leaveStartDate).format("DD MMM YYYY")}</>
      ),
    },
    {
      title: "Leave End Date",
      dataIndex: "leaveEndDate",
      field: "leaveEndDate",
      render: (text, record) => (
        <>{moment(text && text.leaveEndDate).format("DD MMM YYYY")}</>
      ),
    },

    {
      title: "Employee Leave Status",
      dataIndex: "leave_status",
      field: "leave_status",
      render: (text, record) => <>{text.leave_status}</>,
    },

    {
      title: "Status",
      dataIndex: "tl_approval_status",
      field: "tl_approval_status",
      render: (text, record) => (
        <>
          <div className="d-flex">
            {text.tl_approval_status != "Pending" ? (
              <>{text.tl_approval_status}</>
            ) : (
              <select
                value={text.tl_approval_status}
                onChange={(e) => changeStatus(e, text)}
                className="w-100 mb-2 border selectbox"
              >
                <option value="">Select an option</option>
                <option value="Pending">Pending</option>
                {/* <option value="Cancel">Cancel</option> */}
                <option value="Accepted">Accepted</option>
                <option value="Rejected">Rejected</option>
              </select>
            )}

            {text.tl_approval_status == "Rejected" ? (
              <Tooltip title={text.Reason}>
                <IoInformationCircleSharp
                  className="ms-2"
                  style={{ fontSize: "20px" }}
                />
              </Tooltip>
            ) : (
              ""
            )}
          </div>

          {/* {text.leave_status == "Pending" ? (
            <div
              style={{
                color: "#fff",
                backgroundColor: "#F4C430",
                borderRadius: "5px",
                padding: "6px 10px",
                width: "100px",table-striped
                textAlign: "center",
                fontWeight: "600px",
              }}
            >
              {text.leave_status}
            </div>
          ) : text.leave_status == "Cancel" ? (
            <div
              style={{
                color: "white",
                background: "red",
                borderRadius: "5px",
                padding: "6px 10px",
                width: "100px",
                textAlign: "center",
                fontWeight: "600px",
              }}
            >
              {text.leave_status}
            </div>
          ) : text.leave_status == "Accepted" ? (
            <div
              style={{
                color: "white",
                background: "#B4C424",
                borderRadius: "5px",
                padding: "6px 10px",
                width: "100px",
                textAlign: "center",
                fontWeight: "600px",
              }}
            >
              {text.leave_status}
            </div>
          ) : text.leave_status == "Rejected" ? (
            <div
              style={{
                color: "white",
                background: "red",
                borderRadius: "5px",
                padding: "6px 10px",
                width: "100px",
                textAlign: "center",
                fontWeight: "600px",
              }}
            >
              {text.leave_status}
            </div>
          ) : (
            ""
          )} */}
        </>
      ),
    },
    // {
    //   title: "Actions",
    //   dataIndex: "actions",
    //   field: "actions",
    //   render: (text, record) => (
    //     <div className="d-flex align-items-center  gap-4">
    //       <Link to={`/leavesform/${text._id}`} className="text">
    //         <Tooltip title="Edit">
    //           <p >
    //             <EditOutlined />
    //           </p>
    //         </Tooltip>
    //       </Link>
    //       <Tooltip title="Delete">
    //         <Popconfirm
    //           title="Are you sure you want to delete this leave?"
    //           onConfirm={() => handleDelete(text._id)}
    //           okText="Yes"
    //           cancelText="No"
    //         >
    //           <DeleteOutlined />
    //         </Popconfirm>
    //       </Tooltip>
    //     </div>
    //   ),
    // },
  ];
  const newlyAddedChapter =
    array && array.length
      ? array.map((items) => {
          localStorage.setItem("rolesid", items.id);
          return {
            ...items,
          };
        })
      : [];

  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };
  return (
    <Layout>
      <div>
        <div className="main-content">
          <div className="section table table-striped">
            <div className="d-flex align-items-center justify-content-between headings">
              <SectionHeader title="Requested Leaves" />
            </div>
            <Spin spinning={loading}>
              <MaterialTable
                options={{
                  showTitle: false,
                  pageSize: 10,
                  pageSizeOptions: [10, 20, 30, 40, 50],
                  emptyRowsWhenPaging: false,
                }}
                columns={columns}
                data={newlyAddedChapter}
                icons={tableIcons}
              />
            </Spin>
          </div>

          {reason ? (
            <div class="modal d-block scroll_fade">
              <div class="modal-dialog">
                <div class="modal-content border-0 p-3 bg_congoratulations">
                  <div class="textend_modal d-flex">
                    <button
                      type="button"
                      class="btn-close ms-auto"
                      onClick={() => setReasonModal(false)}
                    ></button>
                  </div>

                  <form className="login" onSubmit={handelSubmit}>
                    <div class="form-group">
                      <label for="formGroupExampleInput">Reason</label>
                      <textarea
                        value={form.text}
                        onChange={(e) => {
                          setForm({ ...form, text: e.target.value });
                        }}
                        placeholder="Type Reason..."
                        rows="5"
                        cols="40"
                        required
                        className="w-100"
                      />
                    </div>
                    <button
                      type="submit"
                      class="btn btn-primary ms-auto d-block"
                    >
                      Submit
                    </button>
                  </form>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </Layout>
  );
};

export default requestedLeaveForm;
